import React, { useState, useEffect } from "react";
import Vcode from "react-vcode";

export default function VerificationCode() {
  const [vcodeRandom, setVcodeRandom] = useState("");
  useEffect(() => {
    const str = "1234567890";
    let code = "";
    for (let i = 0; i < 4; i++) {
      const index = Math.floor(Math.random() * 10);
      code += str[index];
    }
    setVcodeRandom(code);
    localStorage.setItem("@fullhouseVcode", code);
  }, []);
  return <Vcode value={vcodeRandom} length={4} width={150} height={40} />;
}
